import adpPortal from '../assets/top-platforms/adpPortal.svg';
import paychex from '../assets/top-platforms/paychex.svg';
import paycom from '../assets/top-platforms/paycom.svg';
import paycor from '../assets/top-platforms/paycor.png';
import paylocity from '../assets/top-platforms/paylocity.png';
import amazon from '../assets/top-platforms/amazon.svg';
import circleK from '../assets/top-platforms/circleK.svg';
import chipotle from '../assets/top-platforms/chipotle.svg';
import aTT from '../assets/top-platforms/AT&T.svg';
import bestBuy from '../assets/top-platforms/BestBuy.svg';
import costco from '../assets/top-platforms/Costco.png';
/*
  These are the currently visible providers and employers in production
  we want to pre-load their images so they are accesible right away.
*/
var topVisibleImages = {
    // Top visible platforms
    '5becff90-1e35-450a-8995-13ac411e749b': adpPortal,
    '3f812c04-ac83-495b-99ca-7ec7d56dc68b': paycom,
    '9a4e213b-aeed-4cb2-aace-696bcd2b1e0d': paychex,
    '913170d1-393c-4f35-8c23-df3133ce7529': paylocity,
    'b0b655f8-4ae6-4d09-a60f-1df9a2a1fd16': paycor,
    // Top visible employers
    'd66e65b2-536d-4b2d-b73c-f6addd66c0f4': amazon,
    '453223da-2006-4f59-843a-15ca597f372e': aTT,
    'd4568c30-a4ae-4b83-a691-c612b200d5b1': bestBuy,
    '90c532eb-ddde-4f1c-8379-7d2a4d8d90e7': chipotle,
    '0ba48840-899b-4e23-9429-9456094bf1f1': circleK,
    '60de4e93-2832-45b9-8b9d-f98c627aa2ee': costco,
};
export default topVisibleImages;
